'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { createSelectorMemoized } from '@base-ui/utils/store';
import { useExtractEventCalendarParameters } from '@mui/x-scheduler-headless/use-event-calendar';
import { useEventCalendarView } from '@mui/x-scheduler-headless/use-event-calendar-view';
import { processDate } from '@mui/x-scheduler-headless/process-date';
import { schedulerOtherSelectors } from '@mui/x-scheduler-headless/scheduler-selectors';
import { EventCalendarProvider } from "../internals/components/EventCalendarProvider.mjs";
import { DayTimeGrid } from "../internals/components/day-time-grid/DayTimeGrid.mjs";
import { EventDialogProvider } from "../internals/components/event-dialog/index.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const DAY_VIEW_CONFIG = {
  siblingVisibleDateGetter: ({
    state,
    delta
  }) => state.adapter.addDays(schedulerOtherSelectors.visibleDate(state), delta),
  visibleDaysSelector: createSelectorMemoized(schedulerOtherSelectors.visibleDate, state => state.adapter, (visibleDate, adapter) => [processDate(visibleDate, adapter)])
};

/**
 * A Day View to use inside the Event Calendar.
 */
export const DayView = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function DayView(props, forwardedRef) {
  // Feature hooks
  const {
    days
  } = useEventCalendarView(DAY_VIEW_CONFIG);
  return /*#__PURE__*/_jsx(DayTimeGrid, _extends({
    ref: forwardedRef,
    days: days
  }, props));
}));

/**
 * A Day View that can be used outside of the Event Calendar.
 */
if (process.env.NODE_ENV !== "production") DayView.displayName = "DayView";
export const StandaloneDayView = /*#__PURE__*/React.forwardRef(function StandaloneDayView(props, forwardedRef) {
  const {
    parameters,
    forwardedProps
  } = useExtractEventCalendarParameters(props);
  return /*#__PURE__*/_jsx(EventCalendarProvider, _extends({}, parameters, {
    children: /*#__PURE__*/_jsx(EventDialogProvider, {
      children: /*#__PURE__*/_jsx(DayView, _extends({
        ref: forwardedRef
      }, forwardedProps))
    })
  }));
});
if (process.env.NODE_ENV !== "production") StandaloneDayView.displayName = "StandaloneDayView";